import { useEffect, useState } from "react";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { toastSuccess } from "../../../components/base/Toast";
import Form from "../../../components/form/Form";
import TextBox from "../../../components/form/TextBox";
import ToggleSwitch from "../../../components/form/ToggleSwitch";
import { useHub } from "../../../core/Global";
import User from "../models/User";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import ModalUpdateJobRates from "../../../components/modals/ModalUpdateJobRates";
import { getEPayRate } from "../../../core/Helper";
import EPayRateFields from "./EPayRateFields";
import { PaymentTypeRate } from "../../../models/AccountPreferences";


type Props = {
    userId?: string
    model?: User
    onUpdate?: (user: User) => void
}

interface IModel {
    rate: any
    fee: any
    creditFee: any
    checkRate: any
    rinvoxPayRate: any
    systemRate: any
    systemFee: any
    systemCCRate: any
    systemCheckRate: any
    systemRinvoxPayRate: any
    ePayRates?: PaymentTypeRate[]
    systemEPayRates?: PaymentTypeRate[]
    apptReminderRate: any
}

export default function AccountTechRates(props: Props) {

    const hub = useHub();
    const [model, modelSet] = useState<IModel>();
    const [working, workingSet] = useState<boolean>(false);

    const [reminderEnabled, reminderEnabledSet] = useState<boolean>(true);
    const [reminderMinutes, reminderMinutesSet] = useState<number>(60);

    const fetch = () => {
        hub.Get(API_ROUTES.Technicians + "defaultrates/" + props.userId, res => {
            if (res.success) {
                modelSet(res.data);
                const mins = Number.parseInt(res.data.apptReminderRate) || 0;
                reminderEnabledSet(mins > 0);
                reminderMinutesSet(mins > 0 ? mins : 60);
            }
        })
    }

    useEffect(() => {
        fetch();
    }, [])


    const [confirmRequired, confirmRequiredSet] = useState<boolean>();
    const [confirmText, confirmTextSet] = useState<string>()
    const [confirmed, confirmedSet] = useState<boolean>();
    const [updateJobs, updateJobsSet] = useState<string[]>();

    useEffect(() => {
        if (confirmed) {
            window.closeModal("modal-confirmedit-techrate");
            $("#btn-update-techrates").click();
        }
    }, [confirmed])

    return (
        <>
            <Form id="user-techdefaults-form" className="form"
                onSubmit={(body, callback) => {

                    workingSet(true);

                    var jobIds = "";
                    updateJobs?.forEach(j => {
                        if (jobIds != "") jobIds += ",";
                        jobIds += j;
                    });

                    hub.Put(API_ROUTES.Technicians + "updatedefaultrates", {
                        ...body,
                        id: props.userId,
                        confirmed: true,
                        updateJobs: jobIds
                    }, res => {
                        confirmedSet(false);
                        if (res.success) {
                            if (res.confirmRequired) {
                                confirmRequiredSet(true)
                                confirmTextSet(res.confirmText)
                                return
                            }
                            toastSuccess("Technician rates has been updated successfully!");
                            if (props.onUpdate) props.onUpdate(res.data);
                        }
                        workingSet(false);
                    })

                }}>
                <div className="card mb-5 mb-xl-10">
                    <div className="card-header border-0">
                        <div className="card-title m-0">
                            <h3 className="fw-bolder m-0">Default Rates</h3>
                        </div>
                        <div className="card-action">
                            <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                                {
                                    working ?
                                        <>
                                            <Icon icon="spinner-third" spin />
                                            <span className="ms-2">Updating...</span>
                                        </>
                                        :
                                        <>
                                            Update Rates
                                        </>
                                }
                            </button>
                        </div>
                    </div>

                    <div className="card-body border-top px-9 pt-10 pb-4">

                        <TextBox name="defaultRate" label="Tech Rate" placeholder={`inherit from system rate (${model?.systemRate}%)`}
                            percent icon="percent" value={model?.rate} />

                        <TextBox name="creditFee" label="Credit Card Rate" placeholder={`inherit from default (${model?.systemCCRate ?? 0}%)`}
                            percent icon="percent" value={model?.creditFee} />

                        <TextBox name="checkRate" label="Check Rate" placeholder={`inherit from default (${model?.systemCheckRate ?? 0}%)`}
                            percent icon="percent" value={model?.checkRate} />

                        <TextBox name="rinvoxPayRate" label="Rinvox Pay Rate" placeholder={`inherit from default (${model?.systemRinvoxPayRate ?? 0}%)`}
                            percent icon="percent" value={model?.rinvoxPayRate} />

                        <EPayRateFields namePrefix="ePayRate" rates={model?.ePayRates}
                            placeholder={t => `inherit from default (${getEPayRate(model?.systemEPayRates, t) ?? 0}%)`} />

                        <TextBox name="defaultFee" label="Tech Fee" placeholder={`inherit from system fee (${model?.systemFee}$)`}
                            money maxLength={3} icon="dollar-sign" value={model?.fee} />

                        <hr />

                        <input type="hidden" name="apptReminderRate" value={reminderEnabled ? reminderMinutes : 0} />

                        <ToggleSwitch label="Send an appointment reminder to the technician before the appointment!"
                            raw small className="mb-5 mt-10"
                            checked={reminderEnabled}
                            onChange={e => reminderEnabledSet(e)} />

                        {
                            reminderEnabled &&
                            <TextBox label="Reminder Time" iconText="Minutes Before Appointment"
                                numeric maxLength={3} value={reminderMinutes.toString()}
                                onTextChanges={e => reminderMinutesSet(Math.max(1, Number.parseInt(e) || 0))} />
                        }

                    </div>

                </div>
            </Form>

            {
                confirmRequired &&
                <Modal id="modal-confirm-tech-rate-update"
                    title="Alert"
                    onConfirm={callback => {
                        confirmedSet(true)
                        callback()
                    }}
                    buttonText="Confirm & Update">
                    <div>
                        {confirmText}
                    </div>
                </Modal>
            }

        </>
    )
}